<template>
  <div class="page-module-wrap">
    <!-- 搜索头部分 start -->
    <div class="search">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <div class="block">
              <button class="button is-info width-1" @click="onShowModal('Add')">添加客服</button>
              <router-link class="button is-success" :to="{ name: 'chatQuickReply' , query:{isIcy:1}}">常用回复管理</router-link>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- 搜索头部分 end -->
    <!-- 列表部分 start -->
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
            <tr>
              <th>客服</th>
              <th>工作时段</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in list">
              <td>{{item.username}}</td>
              <td>
                <el-time-picker
                  is-range
                  arrow-control
                  :clearable="false"
                  v-model="item.timeRange"
                  @change="changeTime(item)"
                >
                </el-time-picker>
              </td>
              <td>
                <button class="button is-danger" @click="onDelete(index)">删除</button>
              </td>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
      <el-dialog :title="modal.title" :visible.sync="modal.visible" :verify="true" >
        <p class="margin-left margin-top">
          <label class="label inline-block r-top">客服：</label>
          <span class="inline-block">
              <el-select v-model="modal.userId" placeholder="请选择" :max-height="250">
                <el-option
                  v-for="item in allOptions.csList"
                  :key="item.userId"
                  :label="item.username"
                  :value="item.userId">
                </el-option>
              </el-select>
          </span>
        </p>
        <p class="margin-left margin-top">
          <label class="label inline-block r-top">设置工作时间段：</label>
          <el-time-picker
            is-range
            arrow-control
            v-model="modal.timeRange"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
          >
          </el-time-picker>
        </p>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/babel">
  export default {
    data(){
      return {
        list:[],
        modal: {
          title: '',
          visible: false,
          type:'',
          userId:'',
          username:'',
          timeRange:[new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 18, 0)]
        },
        allOptions:{
          csList:[]
        },
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getAllOpts()
        this.getList()
      })
    },
    methods:{
      changeTime(item){
        let params = {
          adminUserId:item.userId,
          workStartTime:item.timeRange[0],
          workEndTime:item.timeRange[1],
          isIcyBusinessUserId:1
        }
        HttpRequest.post('/admin.php?method=agencyoperation.doSaveStaff',params).then(response => {
            if(response.data.result){}
          })
      },
      changeEndTime(item,value){

        let params = {
          adminUserId:item.userId,
          workStartTime:item.workStartTime,
          workEndTime:value,
          isIcyBusinessUserId:1
        }
        HttpRequest.post('/admin.php?method=agencyoperation.doSaveStaff',params).then(response => {
          if(response.data.result){}
        })
      },
      cancel(){
        this.modal.visible = false
      },
      confirm(){
        this.modal.visible = false
        let params = {
          adminUserId:this.modal.userId,
          workStartTime:this.modal.timeRange[0],
          workEndTime:this.modal.timeRange[1],
          isIcyBusinessUserId:1
        }
        if(!params.adminUserId){
          this.$message('请选择客服!');
          return false;
        }
        HttpRequest.post('/admin.php?method=agencyoperation.doSaveStaff',params).then(response => {
          if(response.data.result){
            this.modal.visible = false
            this.getList()
          }
        })
      },
      getList(){
        let params = {
          isIcyBusinessUserId:1//区分是否icy
        }
        HttpRequest.post('/admin.php?method=agencyoperation.showStaff',params).then(response => {
          this.list = _.toArray(response.data.list).map((item) => {
            return {
              username: item.username,
              userId: item.userId,
              timeRange: [new Date("2017-11-11 " + item.workStartTime), new Date("2017-11-11 " + item.workEndTime)]
            }
          })
        })
      },
      onShowModal(type,index){
        switch (type) {
          case 'Add':
            this.onShowAddModal(type);
            break;
        }
      },
      onShowAddModal(type){
        this.modal.type = type;
        this.modal.title = "添加客服";
        this.modal.visible = true;
       /* this.modal.bodyStyle = {
          'overflow-x': 'initial',
          'overflow-y': 'initial'
        }*/
      },
      getAllOpts(){
        //客服列表
        HttpRequest.post('/admin.php?method=agencyoperation.getAdminInfo').then(response => {
          this.allOptions.csList = _.toArray(response.data)
          this.allOptions.csList.unshift({
            userId: -1,
            name: '全部'
          })
        })
      },
      /**
       * 删除客服
       * @param index
       */
      onDelete(index){
        if(!confirm("确认删除？"))return false;
        let params = {
          adminId:this.list[index].userId,
          isIcyBusinessUserId:1
        }
        HttpRequest.post('/admin.php?method=agencyoperation.doRemoveStaff',params).then(response => {
          if(response.data.result){
            this.$message('删除成功！')
            this.getList()
          }
        })
      },
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .page-module-wrap {
    th {
      text-align: center;
      padding: 4px 5px;
    }
    td {
      text-align: center;
      padding: 4px 5px;
      span {
        word-break: break-all;
      }
    }
    p {
      word-break: break-all;
    }
    .clearfix:after {
      content: ".";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .clearfix {
      _overflow: hidden;
    }
    .fleft {
      float: left;
    }
    .fright {
      float: right;
    }
    .red {
      color: red;
    }
    .green {
      color: green;
    }
    .margin-top {
      margin-top: 10px;
    }
    .margin-bottom {
      margin-bottom: 10px;
    }
    .margin-left {
      margin-left: 40px;
    }
    .width-2 {
      width: 200px;
    }
    .width-3 {
      width: 200px;
      input {
        width: 180px;
      }
    }
    .width-50 {
      width: 50px;
    }
    .inline-block {
      display: inline-block;
    }
    .vertical-middle {
      vertical-align: middle;
    }

    .control {
      display: inline-block;
      margin-right: 20px;
    }
    .margin-left1 {
      margin-left: 20px;
    }
    .r-top {
      position: relative;
      top: 5px;
    }
    .danger {
      background-color: #ed6c63;
      border-color: transparent;
      color: white;
    }
    .list-wrap {
      padding-bottom: 40px;
      .order-item {
        margin-bottom: 30px;
        .img-goods {
          width: 90%;
        }
      }
      .goods-img {
        min-width: 70px;
      }
      .goods-name {
        border: none;
        resize: none;
        height: 80px;
      }
      .goods-name-overflow {
        border: 1px solid red;
      }
    }
    .red {
      color: red;
    }
    .margin-plan {
      margin-top: 10px;
      margin-left: 100px;
    }
    .modal-tip {
      color: #ccc;
      position: relative;
      top: 5px;
    }
    .business-block {
      float: left;
      margin-left: 5px;
      height: 32px;
      line-height: 32px;
      padding: 0 5px;
      border: 1px solid #42AFE3;
      color: #42AFE3;
      position:relative;
      .delete-icon {
        display: none;
        position: absolute;
        top:1px;
        right: 1px;
        color: #E61414;
        font-size: 10px;
        cursor: pointer;
      }
      &:hover {
        .delete-icon {
          display: inline-block;
        }
      }
    }
  }

</style>
